import type { FC } from "react";
import type { StripeInvoice } from "@/API";
import Text from "../Text";
import dayjs from "dayjs";
import Badge from "../Badge";
import { Button } from "../ui/button";
import { useTranslation } from "react-i18next";

type Props = {
  invoice: StripeInvoice;
  canDownload?: boolean;
};

const InvoiceRow: FC<Props> = ({ invoice, canDownload }) => {
  const { t } = useTranslation();
  const { createdAt, amount, status, invoiceUrl, invoicePdfUrl } = invoice;

  return (
    <div className="bg-[white] min-h-[72px] flex items-center justify-between rounded-[12px] px-[16px]">
      <div className="flex flex-col gap-[4px]">
        <Text fontWeight={400} fontSize={14} className="capitalize">
          {dayjs(createdAt).format("dddd D MMMM YYYY")}
        </Text>
        <Text fontWeight={600} fontSize={12}>
          {`${(amount / 100).toFixed(2)} €`}
        </Text>
      </div>

      <div className="flex items-center gap-[12px]">
        <Badge state="success">
          <Text fontWeight={600} fontSize={14} color="#216E4E">
            {t(status)}
          </Text>
        </Badge>
        {invoiceUrl && (
          <a target="_blank" rel="noopener noreferrer" href={invoiceUrl}>
            <Button variant="secondaryFilled">{t("see")}</Button>
          </a>
        )}
        {canDownload && invoicePdfUrl && (
          <a target="_blank" rel="noopener noreferrer" href={invoicePdfUrl}>
            <Button variant="secondaryFilled">{t("download")}</Button>
          </a>
        )}
      </div>
    </div>
  );
};

export default InvoiceRow;
